import React from 'react';

const LockedFeature = ({ title, description, shadow = true }) => {
    return (
        <div className="stock-dashboard-wrapper mt-4 px-3">
             <div className={`border-0 ${shadow ? "shadow-sm " : ""}rounded-4 p-5 mb-4 text-center`}>
                <div className="">
                    <div className="mb-3">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    <h5 className="mb-3 fw-bold text-dark">{title || "Feature Locked"}</h5>
                    <p className="text-muted mb-4" style={{maxWidth: '400px', margin: '0 auto'}}>
                        {description || "Upgrade to Premium or Pro plan to unlock this feature."}
                    </p>
                    <a href="/setting?loc=2" className="subscription-btn">
                        Upgrade Plan
                    </a>
                </div>
             </div>
        </div>
    );
};

export default LockedFeature;
